import gql from 'graphql-tag';

import { CertifyUserTicketMutation } from 'types/graphql-api.generated';

import requestGraph from 'common/api/GraphApi/requestGraph';
import { GRAPH_COUNTRY_NAME } from 'common/configuration/constants';
import {
  TrackingEventNames,
  TrackingContextObject
} from 'common/constants/trackingEventsNames';
import eventEmitter from 'common/services/events/eventEmitter';

const ENTITY_FRAGMENT = gql`
  fragment CertifyUserTicketEntityFragment on Node {
    id
    __typename
    ... on Movie {
      title
      poster {
        path
      }
      flags {
        isComingSoon
        hasShowtime
      }
      releases(country: $brandCountry, type: RELEASED) {
        releaseDate {
          date
        }
      }
    }
    ... on Series {
      title
      originalBroadcast {
        firstAiredDate {
          date
        }
      }
    }
    ... on Season {
      number
      status
      data {
        rules {
          rating {
            has_mandatory_review
          }
        }
      }
    }
    ... on Program {
      title
    }
    ... on Episode {
      title
    }
  }
`;

const SOCIAL_ACTION_FRAGMENT = gql`
  fragment CertifyUserTicketSocialActionFragment on SocialActionInterface {
    __typename
    id
    updatedAt
    relatedEntity {
      __typename
      id
    }
    ... on Opinion {
      content {
        rating(base: 5)
        certificationRating
        review
        status
      }
    }
  }
`;

const USER_ENTITY_LEAF_FRAGMENT = gql`
  fragment CertifyUserTicketUserEntityLeafFragment on UserEntityLeafInterface {
    id
    entity {
      ...CertifyUserTicketEntityFragment
    }
    opinion {
      ...CertifyUserTicketSocialActionFragment
    }
    wantToSee {
      ...CertifyUserTicketSocialActionFragment
    }
    helpful {
      ...CertifyUserTicketSocialActionFragment
    }
    unhelpful {
      ...CertifyUserTicketSocialActionFragment
    }
    seenIt {
      ...CertifyUserTicketSocialActionFragment
    }
  }
  ${SOCIAL_ACTION_FRAGMENT}
  ${ENTITY_FRAGMENT}
`;

export const certifyUserTicket = async (
  entityId: string,
  context?: TrackingContextObject
) => {
  const QUERY = gql`
    mutation CertifyUserTicket($entityId: String!, $brandCountry: CountryCode) {
      certifyUserTicket(input: { id_entity: $entityId }) {
        userEntityLeaf {
          ...CertifyUserTicketUserEntityLeafFragment
        }
      }
    }
    ${USER_ENTITY_LEAF_FRAGMENT}
  `;

  const response = await requestGraph<{ data: CertifyUserTicketMutation }>({
    query: QUERY,
    variables: {
      entityId,
      brandCountry: GRAPH_COUNTRY_NAME
    }
  });

  const userEntityLeaf = response.data?.certifyUserTicket?.userEntityLeaf;

  if (userEntityLeaf) {
    eventEmitter.emit(TrackingEventNames.CERTIFY_TICKET_EVENT, {
      context,
      response: userEntityLeaf
    });
  }

  return userEntityLeaf;
};
